import React, { useRef, useState } from 'react';
import { AlertTriangle, Loader2, Upload } from 'lucide-react';
import { toast } from 'sonner';
import api from '../api';

// Staff upload the consent the patient signed in a PDF viewer (or a photo of the signed paper); warns if the signature box looks empty
export const UploadSignedConsent = ({ patientId, onSaved, btnClass }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [warning, setWarning] = useState(null);
  const send = async (file, force = false) => {
    setBusy(true);
    const fd = new FormData();
    fd.append('patientId', patientId); fd.append('force', force ? 'true' : 'false'); fd.append('file', file);
    try {
      const r = await api.post('/consent-sign/upload-signed', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success(r.data.message); setWarning(null); onSaved?.();
    } catch (e) {
      if (e.response?.status === 409) setWarning({ file, text: e.response.data.detail });
      else toast.error(e.response?.data?.detail || 'Upload failed');
    } finally {
      setBusy(false);
      if (input.current) input.current.value = '';
    }
  };
  return (
    <>
      <input ref={input} type="file" accept="application/pdf,image/jpeg,image/png" className="hidden" data-testid="consent-upload-input"
        onChange={e => e.target.files[0] && send(e.target.files[0])} />
      <button onClick={() => input.current?.click()} disabled={busy} className={btnClass} data-testid="consent-upload-signed">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload Signed Consent
      </button>
      {warning && (
        <div className="basis-full mt-2 p-3 rounded-lg bg-amber-50 border border-amber-300 text-sm text-amber-900 flex flex-wrap items-center gap-3" data-testid="consent-upload-warning">
          <AlertTriangle className="w-4 h-4 shrink-0" /> <span className="flex-1 min-w-[200px]">{warning.text}</span>
          <button onClick={() => send(warning.file, true)} disabled={busy} className="px-3 py-1.5 rounded-full bg-gray-900 text-[#d4af37] text-xs font-semibold" data-testid="consent-upload-force">Save anyway</button>
          <button onClick={() => setWarning(null)} className="px-3 py-1.5 rounded-full border text-xs" data-testid="consent-upload-cancel">Cancel</button>
        </div>
      )}
    </>
  );
};
